import { useCallback, useEffect, useState } from 'react';
import useEventListener from './useEventListener';

function useWindowSize() {
  const [size, setSize] = useState({
    width: 0,
    height: 0,
  });

  const handleResize = useCallback(() => {
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    const height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;

    setSize({
      width,
      height,
    });
  }, []);

  useEventListener('resize', handleResize);

  useEffect(() => {
    handleResize();
  }, []);

  return [size.width, size.height];
}

export default useWindowSize;
